import * as React from 'react';

import { useGlobalState } from '../../contexts/state/GlobalStateContext';
import { Pane } from '../../ui/Pane';
import { useSpeciesContext } from './ISpeciesContext';
import { ISpecies } from '../../api/models/ISpecies';
import { SpeciesForm } from './SpeciesForm';

const SpeciesEdit = () => {
  const ctx = useSpeciesContext();
  const globalState = useGlobalState();

  // The mode === 'edit' switch in SpeciesManager guarantees ctx.species is
  // populated before this component is rendered.
  const initialSpecies = ctx.species;
  const species = React.useRef<ISpecies | null>(initialSpecies ? {...initialSpecies} : null);
  const [valid, setValid] = React.useState(true);
  const [saving, setSaving] = React.useState(false);

  if (!ctx.species || !species.current) return null;
  const ctxSpecies = ctx.species;
  const speciesRef = species.current;

  const handleChange = (value: ISpecies, forceupdate: boolean) => {
    Object.assign(speciesRef, value);
  }

  const handleValidate = (_valid: boolean) => {
    setValid(_valid);
  }

  const handleSave = async () => {
    if(!valid) return;
    setSaving(true);
    const result = await globalState.updateSpecies(ctxSpecies, speciesRef)
    setSaving(false);
    if(result) {
      ctx.setMode('view');
    }
  }

  return (
    <>
      <Pane.Heading>
        <Pane.Title>{ctxSpecies.name}</Pane.Title>
      </Pane.Heading>
      <Pane.Subheader expandable>EDIT SPECIES</Pane.Subheader>

      <Pane.Body>
        <SpeciesForm species={ctxSpecies} dirty={true} onChange={handleChange} onValidate={handleValidate}/>
      </Pane.Body>

      <Pane.Footer>
        <Pane.CancelButton onClick={() => ctx.setMode('view')}/>
        <Pane.SubmitButton disabled={saving || !valid} working={saving} onClick={handleSave}/>
      </Pane.Footer>
    </>
  );
}

export { SpeciesEdit }
